<template>
  <div
    v-if="loading"
    class="local-loading-wrapper"
    :style="{
      zIndex,
      width: containerWidth,
      height: containerHeight,
    }"
  >
    <div class="local-overlay" :class="overlayClass">
      <div class="local-loading">
        <van-loading :size="size" :color="color" :type="type" vertical>
          {{ text }}
        </van-loading>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GlobalLoading",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: "加载中...",
    },
    size: {
      type: String,
      default: "36px",
    },
    color: {
      type: String,
      default: "#1989fa", // vant主题蓝
    },
    type: {
      type: String,
      default: "spinner", // 可选circular
    },
    zIndex: {
      type: Number,
      default: 2000,
    },
    overlayClass: {
      type: String,
      default: "loading-overlay",
    },
    containerClass: {
      type: String,
      default: "loading-container",
    },
  },
  data() {
    return {
      containerWidth: "100%",
      containerHeight: "100%",
    };
  },
  computed: {
    loading(){
      
      return this.show;
    }
  },
  mounted() {
    this.$nextTick(() => {
      const container = this.$el.parentElement;
      container.classList.add(this.containerClass);
      this.setContainerSize();
    });
  },
  methods: {
    setContainerSize() {
      const container = this.$el.parentElement;
      const rect = container.getBoundingClientRect();
      this.containerWidth = `${rect.width}px`;
      this.containerHeight = `${rect.height}px`;
    },
  },
};
</script>

<style scoped lang="less">
.fullscreen-loading {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.loading-overlay {
  background-color: rgba(255, 255, 255, 0.9);
}

@keyframes van-rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
